import TextField from "@mui/material/TextField";
import { useCallback } from "react";
import type { Observable } from "rxjs";
import { useObservable } from "../../hooks/useObservable";
import { selectOnFocusHandler } from "./utils";

interface NumberFilterProps {
  readonly label: string;
  readonly onChange: (value: number | undefined) => void;
  readonly value$: Observable<number | undefined>;
}

export const NumberFilter = (props: NumberFilterProps) => {
  const { label, onChange, value$ } = props;

  const value = useObservable(value$, undefined);
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value;

      onChange(value === "" ? undefined : +value);
    },
    [onChange],
  );

  return (
    <TextField
      fullWidth
      label={label}
      onChange={handleChange}
      onFocus={selectOnFocusHandler}
      size="small"
      type="number"
      value={value ?? ""}
    />
  );
};
